export const initServiceWorkers = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(registration => {
        // eslint-disable-next-line no-console
        console.log(
          'Service worker registration successful, scope is:',
          registration.scope
        );
      })
      .catch(err => {
        console.error('Service worker registration failed, error:', err); // eslint-disable-line no-console
      });
  }
};
